import React, { useEffect } from 'react'
import { useSelector } from 'APP/Hooks/redux'
import type { RootState } from 'APP/Store/CreateStore'
import { isEmbeddedEnvironment } from 'APP/BrownfieldBridge/utils'
import { CommonActions } from '@react-navigation/native'
import { navigationRef as Nav } from 'APP/Nav'
import { shouldShowAccountLinking } from 'APP/Lib/AccountLinkingHelpers'

// Temporary embedded workaround. DIA-87422 is the proper StartupSaga/PatientSaga refactor.
// Gate the side effect on navigationReady only; children must remain mounted when readiness changes.
const AccountLinkingGuard = ({ children }: { children: React.ReactNode }) => {
  const needsAccountLinking = useSelector(shouldShowAccountLinking)
  const isNavigationReady = useSelector((state: RootState) => state.app.navigationReady)

  useEffect(() => {
    if (!isEmbeddedEnvironment() || !needsAccountLinking || !isNavigationReady) return

    const currentRoute = Nav.getCurrentRoute()
    if (currentRoute?.name !== 'accountLinking') {
      Nav.dispatch(CommonActions.reset({ index: 0, routes: [{ name: 'accountLinking' }] }))
    }
  }, [needsAccountLinking, isNavigationReady])

  return <>{children}</>
}

export default AccountLinkingGuard
